import { SkuCodes } from "@sticker-giant/sg-frontend-common";

export enum PackagingMode {
  Roll = "roll",
  Bundle = "bundle",
}

export function resolvePackagingMode(finishSku: string | undefined): PackagingMode | undefined {
  if (finishSku === SkuCodes.Finish.Individual || finishSku === SkuCodes.Finish.IndividualSheets) {
    return PackagingMode.Bundle;
  }

  if (finishSku === SkuCodes.Finish.OnRolls || finishSku === SkuCodes.Finish.OnRollsWithPerforations) {
    return PackagingMode.Roll;
  }

  return undefined;
}
